import React, {
  lazy,
  Suspense,
  useEffect,
  useMemo,
  useRef,
  useState,
  MouseEvent,
} from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// import { Broker } from "./interface";
// import "./InputBox.scss";
import {
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_DensityState,
  type MRT_Row,
  MRT_SortingState,
  type MRT_TableOptions,
  MRT_VisibilityState,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { type User, fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Form, Row } from "reactstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import { toast } from "react-toastify";
import { StyledTableFirstSecond } from "../Book/TableBook";
import { showDeleteConfirmModal } from "../../Components/ConfirmModal";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";

type counterPartyType = {
  id: string;
  customer_company_name: string;
  email: string;
  account?: number;
  credit_limit?: number;
  remarks: string;
};

type DropdownOption = {
  value: string | number;
  label: string;
};
const Example = () => {
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const isFirstRender = useRef(true);
  const [filterModes, setFilterModes] = useState<
    { mode: string; id: string; value: unknown }[]
  >([]);

  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [columnVisibility, setColumnVisibility] = useState<MRT_VisibilityState>(
    {}
  );
  const [density, setDensity] = useState<MRT_DensityState>("comfortable");
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(
    undefined
  );
  const [showGlobalFilter, setShowGlobalFilter] = useState(true);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [brokerName, setBrokerName] = useState<string>("");
  const [inputBackgroundColour, setInputBackgroundColour] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 15, //set different default page size by initializing the state here
  });

  const addButtonRef = useRef<HTMLButtonElement | null>(null);
  const [showRowResizing, setShowRowResizing] = useState<boolean>(true);
  const [totalCount, setTotalCount] = useState(0);

  // First, let's fix the state management by properly defining all the required state variables

  const [contractName, setContractName] = useState<string>("");

  const [tick, setTick] = useState<string>("");

  const [kbblConversion, setKbblConversion] = useState<string>("");
  const [priceConversion, setPriceConversion] = useState<string>("");
  const [fwMonths, setFwMonths] = useState<string>("");
  const [exchangeFee, setExchangeFee] = useState<string>("");
  const [exchangeClearanceFee, setExchangeClearanceFee] = useState<string>("");
  const [exchangeFeeBlocked, setExchangeFeeBlocked] = useState<string>("");
  const [exchangeClearanceFeeBlocked, setExchangeClearanceFeeBlocked] =
    useState<string>("");
  const [screenFee, setScreenFee] = useState<string>("");
  const [iceClearEUScreenFee, setIceClearEUScreenFee] = useState<string>("");
  const [iceClearEUEUBlockFee, setIceClearEUEUBlockFee] = useState<string>("");
  const [cashSettle, setCashSettle] = useState<string>("");
  const [gmifcCode, setGmifcCode] = useState<string>("");
  const [physicalCode, setPhysicalCode] = useState<string>("");
  const [logicalCode, setLogicalCode] = useState<string>("");
  const [symbolCode, setSymbolCode] = useState<string>("");
  const [plattsCode, setPlattsCode] = useState<string>("");

  // State for dropdown options

  const [singleDiffOptions, setSingleDiffOptions] = useState<DropdownOption[]>(
    []
  );
  const [majorMiniOptions, setMajorMiniOptions] = useState<DropdownOption[]>(
    []
  );
  const [fullBalMonthOptions, setFullBalMonthOptions] = useState<
    DropdownOption[]
  >([]);
  const [contract1Options, setContract1Options] = useState<DropdownOption[]>(
    []
  );
  const [contract2Options, setContract2Options] = useState<DropdownOption[]>(
    []
  );
  const [majorMiniConnOptions, setMajorMiniConnOptions] = useState<
    DropdownOption[]
  >([]);
  const [balMonthConnOptions, setBalMonthConnOptions] = useState<
    DropdownOption[]
  >([]);
  const [unitOptions, setUnitOptions] = useState<DropdownOption[]>([]);
  const [holidayOptions, setHolidayOptions] = useState<DropdownOption[]>([]);

  // State for selected values
  const [derivative, setDerivative] = useState<string>("");
  const [singleDiff, setSingleDiff] = useState<string>("");
  const [majorMini, setMajorMini] = useState<string>("");
  const [fullBalMonth, setFullBalMonth] = useState<string>("");
  const [contract1, setContract1] = useState<string>("");
  const [contract2, setContract2] = useState<string>("");
  const [majorMiniConn, setMajorMiniConn] = useState<string>("");
  const [balMonthConn, setBalMonthConn] = useState<string>("");
  const [unit, setUnit] = useState<string>("");
  const [holiday, setHoliday] = useState<string>("");

  const [derivativeOptions, setDerivativeOptions] = useState<DropdownOption[]>(
    []
  );

  useEffect(() => {
    const derivativeData = [
      { derivatives: "future" },
      { derivatives: "swaps" },
    ];
    setDerivativeOptions(
      derivativeData.map((item) => ({
        value: item.derivatives,
        label: item.derivatives,
      }))
    );
  }, []);

  useEffect(() => {
    // Example data
    const data = [
      {
        id: "1",
        derivatives: "Futures 333",
        single_diff: "Single",
        major_mini: "Major",
        full_bal_month: "Full Month",
        contract_name: "Marine Fuel 0.5% FOB Rotterdam Barges",
        tick: 100,
        kbbl_conversion_value: 1.0,
        price_conversion: 42.0,
        f_w_months: 0,
        exchange_fees: 0.25,
        exchange_clearance_fees: 0.1,
        exchange_fees_blocked: "Yes",
        exchange_clearance_fees_blocked: "No",
        screen_fees: "Standard",
        ice_clearer_eu_screen_fees: "EU Standard",
        ice_clearer_eu_block_fee: "Blocked",
        cash_settle: "Yes",
        gimfc_code: "G1234",
        physical_code: "P1234",
        logical_code: "L1234",
        symbol_code: "B1234",
        platts_code: "PLT123",
        contract1: "Marine Fuel 0.5% FOB Rotterdam Barges",
        contract2: "Middle East Naphtha FOB Arab Gulf",
        major_mini_connection: "Connection 1",
        bal_month_connection: "Connection 2",
        unit: "bbl",
        holiday: "Holiday 1",
      },
      {
        id: "2",
        derivatives: "Swaps 444",
        single_diff: "Diff",
        major_mini: "Mini",
        full_bal_month: "Balance Month",
        contract_name: "Naphtha CIF NWE Cargoes",
        tick: 200,
        kbbl_conversion_value: 1.5,
        price_conversion: 50.0,
        f_w_months: 1,
        exchange_fees: 0.3,
        exchange_clearance_fees: 0.15,
        exchange_fees_blocked: "No",
        exchange_clearance_fees_blocked: "Yes",
        screen_fees: "Premium",
        ice_clearer_eu_screen_fees: "EU Premium",
        ice_clearer_eu_block_fee: "Unblocked",
        cash_settle: "No",
        gimfc_code: "G5678",
        physical_code: "P5678",
        logical_code: "L5678",
        symbol_code: "B5678",
        platts_code: "PLT567",
        contract1: "Singapore Jet Kerosene",
        contract2: "Middle East Naphtha FOB Arab Gulf",
        major_mini_connection: "Connection 3",
        bal_month_connection: "Connection 4",
        unit: "MT",
        holiday: "Holiday 2",
      },
    ];

    // Derivative options data is fetched from the API and stored in the derivativeOptions state variable.

    setSingleDiffOptions(
      data.map((item) => ({ value: item.single_diff, label: item.single_diff }))
    );
    setMajorMiniOptions(
      data.map((item) => ({ value: item.major_mini, label: item.major_mini }))
    );
    setFullBalMonthOptions(
      data.map((item) => ({
        value: item.full_bal_month,
        label: item.full_bal_month,
      }))
    );
    setContract1Options(
      data.map((item) => ({ value: item.contract1, label: item.contract1 }))
    );
    setContract2Options(
      data.map((item) => ({ value: item.contract2, label: item.contract2 }))
    );
    setMajorMiniConnOptions(
      data.map((item) => ({
        value: item.major_mini_connection,
        label: item.major_mini_connection,
      }))
    );
    setBalMonthConnOptions(
      data.map((item) => ({
        value: item.bal_month_connection,
        label: item.bal_month_connection,
      }))
    );
    setUnitOptions(
      data.map((item) => ({ value: item.unit, label: item.unit }))
    );
    setHolidayOptions(
      data.map((item) => ({ value: item.holiday, label: item.holiday }))
    );

    // Additional fields can be mapped similarly if needed
  }, []);
  const [counterPartyData, setCounterPartyData] = useState<User[]>([]);
  useEffect(() => {
    //do something when the pagination state changes
  }, [pagination]);

  useEffect(() => {
    const columnFilters = localStorage.getItem("mrt_columnFilters_table_1");
    const columnVisibility = localStorage.getItem(
      "mrt_columnVisibility_table_1"
    );
    const density = localStorage.getItem("mrt_density_table_1");
    const globalFilter = localStorage.getItem("mrt_globalFilter_table_1");
    const showGlobalFilter = localStorage.getItem(
      "mrt_showGlobalFilter_table_1"
    );
    const showColumnFilters = localStorage.getItem(
      "mrt_showColumnFilters_table_1"
    );
    const sorting = localStorage.getItem("mrt_sorting_table_1");

    if (columnFilters) {
      setColumnFilters(JSON.parse(columnFilters));
    }
    if (columnVisibility) {
      setColumnVisibility(JSON.parse(columnVisibility));
    }
    if (density) {
      setDensity(JSON.parse(density));
    }
    if (globalFilter) {
      setGlobalFilter(JSON.parse(globalFilter) || undefined);
    }
    if (showGlobalFilter) {
      setShowGlobalFilter(JSON.parse(showGlobalFilter));
    }
    if (showColumnFilters) {
      setShowColumnFilters(JSON.parse(showColumnFilters));
    }
    if (sorting) {
      setSorting(JSON.parse(sorting));
    }
    isFirstRender.current = false;
  }, []);

  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_columnFilters_table_1",
      JSON.stringify(columnFilters)
    );
  }, [columnFilters]);
  //save states to local storage
  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_columnFilters_table_1",
      JSON.stringify(columnFilters)
    );

    console.log("columnFilters", "columnFilters---------------", columnFilters);
  }, [columnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_columnVisibility_table_1",
      JSON.stringify(columnVisibility)
    );
  }, [columnVisibility]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem("mrt_density_table_1", JSON.stringify(density));
  }, [density]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_globalFilter_table_1",
      JSON.stringify(globalFilter ?? "")
    );
  }, [globalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_showGlobalFilter_table_1",
      JSON.stringify(showGlobalFilter)
    );
  }, [showGlobalFilter]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem(
      "mrt_showColumnFilters_table_1",
      JSON.stringify(showColumnFilters)
    );
  }, [showColumnFilters]);

  useEffect(() => {
    if (isFirstRender.current) return;
    localStorage.setItem("mrt_sorting_table_1", JSON.stringify(sorting));
  }, [sorting]);

  const columns = useMemo<MRT_ColumnDef<User>[]>(
    () => [
      // {
      //   accessorKey: "id",
      //   header: "Id",
      //   enableEditing: false,
      // },
      {
        accessorKey: "derivatives",
        header: "Derivative",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.customerCompany,
          helperText: validationErrors?.customerCompany,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              customerCompany: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "single_diff",
        header: "Single/Diff",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.account,
          helperText: validationErrors?.account,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              account: undefined,
            }),
        },
      },
      {
        accessorKey: "major_mini",
        header: "Major/Mini",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.email,
          helperText: validationErrors?.email,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              email: undefined,
            }),
        },
      },

      {
        accessorKey: "full_bal_month",
        header: "Full/Bal Month",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "contract_name",
        header: "Contract Name",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "contract1",
        header: "Contract 1",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "contract2",
        header: "Contract 2",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "major_mini_connection",
        header: "Major Mini Connection",
        //  size: "auto",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "bal_month_connection",
        header: "Bal Month Connection",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "unit",
        header: "Unit",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "tick",
        header: "Tick",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "holiday",
        header: "Holiday",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "kbbl_conversion_value",
        header: "bbl Conversion value",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "price_conversion",
        header: "Price Conversion Value",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "f_w_months",
        header: "F.W Months",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "exchange_fees",
        header: "Exchange Fee",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "exchange_clearance_fees",
        header: "Exchange Clearance Fees",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "exchange_fees_blocked",
        header: "Exchange Fees (Blocked)",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "exchange_clearance_fees_blocked",
        header: "Exchange Clearance Fee (Blocked)",
        minSize: 400,
        maxSize: 500,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "screen_fees",
        header: "Screen Fee",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "ice_clearer_eu_screen_fees",
        header: "ICE Clear EU Screen Fee",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "ice_clearer_eu_block_fee",
        header: "ICE Clear EU EU Block Fee",
        minSize: 300,
        maxSize: 400,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "cash_settle",
        header: "Cash Settle",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "gimfc_code",
        header: "GMIFC Code",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "physical_code",
        header: "Physical Code",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "logical_code",
        header: "Logical Code",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "symbol_code",
        header: "Symbol Code",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      {
        accessorKey: "platts_code",
        header: "Platts Code",

        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.remarks,
          helperText: validationErrors?.remarks,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              remarks: undefined,
            }),
        },
      },
      // {
      //   accessorKey: "state",
      //   header: "State",

      //   filterVariant: "multi-select",
      //   filterSelectOptions: usStateList,
      //   editVariant: "select",
      //   editSelectOptions: usStates,

      //   muiEditTextFieldProps: {
      //     select: true,
      //     error: !!validationErrors?.state,
      //     helperText: validationErrors?.state,
      //   },
      // },
    ],
    [validationErrors]
  );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data,
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetData(filterModes, pagination, setTotalCount, sorting);
  //call UPDATE hook

  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  // CREATE FUNCTION TO ADD NEW A BROKER
  const createBroker = async (counterparty: {
    derivatives: string;
    single_diff: string;
    major_mini: string;
    full_bal_month: string;
    contract_name: string;
    tick: number;
    kbbl_conversion_value: number;
    price_conversion: number;
    f_w_months: number;
    exchange_fees: number;
    exchange_clearance_fees: number;
    exchange_fees_blocked: string;
    exchange_clearance_fees_blocked: string;
    screen_fees: string;
    ice_clearer_eu_screen_fees: string;
    ice_clearer_eu_block_fee: string;
    cash_settle: string;
    gimfc_code: string;
    physical_code: string;
    logical_code: string;
    symbol_code: string;
    platts_code: string;
    contract1: string | null;
    contract2: string | null;
    major_mini_connection: string | null;
    bal_month_connection: string | null;
    unit: string;
    holiday: string;
  }) => {
    if (!counterparty.contract_name) {
      toast.error("Contract Name is required!");
      return;
    }

    try {
      console.log("API Payload:", counterparty);

      // Make an API call to add the contract
      await axiosInstance.post(
        `${backendbaseUrl}/paper-app/contracts/`,
        counterparty
      );

      // Invalidate the query to refetch the updated data
      queryClient.invalidateQueries({ queryKey: ["users"] });

      // Show a success message
      toast.success("Contract added successfully!");
    } catch (error) {
      console.error("Error adding contract:", error);
      toast.error("Failed to add contract. Please try again.");
    }
  };

  const [formData, setFormData] = useState<{
    derivative: string;
  }>({ derivative: "" });

  const handleChange = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    console.log("Updated derivative value:", formData);
  }, [formData.derivative]);

  // create by submitting the form
  const formCreate = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!contractName.trim()) {
      toast.error("Contract Name is required!");
      return;
    }
    if (!tick || isNaN(Number(tick))) {
      toast.error("Tick must be a valid number!");
      return;
    }
    if (!kbblConversion || isNaN(Number(kbblConversion))) {
      toast.error("Kbbl Conversion Value must be a valid number!");
      return;
    }
    if (!priceConversion || isNaN(Number(priceConversion))) {
      toast.error("Price Conversion Value must be a valid number!");
      return;
    }

    const counterparty = {
      derivatives: derivative,
      single_diff: singleDiff,
      major_mini: majorMini,
      full_bal_month: fullBalMonth,
      contract_name: contractName,
      tick: Number(tick),
      kbbl_conversion_value: Number(kbblConversion),
      price_conversion: Number(priceConversion),
      f_w_months: Number(fwMonths),
      exchange_fees: Number(exchangeFee),
      exchange_clearance_fees: Number(exchangeClearanceFee),
      exchange_fees_blocked: exchangeFeeBlocked,
      exchange_clearance_fees_blocked: exchangeClearanceFeeBlocked,
      screen_fees: screenFee,
      ice_clearer_eu_screen_fees: iceClearEUScreenFee,
      ice_clearer_eu_block_fee: iceClearEUEUBlockFee,
      cash_settle: cashSettle,
      gimfc_code: gmifcCode,
      physical_code: physicalCode,
      logical_code: logicalCode,
      symbol_code: symbolCode,
      platts_code: plattsCode,
      contract1: contract1 || null,
      contract2: contract2 || null,
      major_mini_connection: majorMiniConn || null,
      bal_month_connection: balMonthConn || null,
      unit: unit,
      holiday: holiday,
    };

    console.log("Submitting Contract:", counterparty);

    try {
      await createBroker(counterparty);

      // Reset the form
      setDerivative("");
      setSingleDiff("");
      setMajorMini("");
      setFullBalMonth("");
      setContractName("");
      setTick("");
      setKbblConversion("");
      setPriceConversion("");
      setFwMonths("");
      setExchangeFee("");
      setExchangeClearanceFee("");
      setExchangeFeeBlocked("");
      setExchangeClearanceFeeBlocked("");
      setScreenFee("");
      setIceClearEUScreenFee("");
      setIceClearEUEUBlockFee("");
      setCashSettle("");
      setGmifcCode("");
      setPhysicalCode("");
      setLogicalCode("");
      setSymbolCode("");
      setPlattsCode("");
      setContract1("");
      setContract2("");
      setMajorMiniConn("");
      setBalMonthConn("");
      setUnit("");
      setHoliday("");

      toast.success("Contract added successfully!");
    } catch (error) {
      console.error("Error creating contract:", error);
      toast.error("Failed to add contract. Please try again.");
    }
  };

  //CREATE action
  const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    // ... (keep your existing validation logic)

    const counterparty = {
      derivatives: derivative,
      single_diff: singleDiff,
      major_mini: majorMini,
      full_bal_month: fullBalMonth,
      contract_name: contractName,
      tick: Number(tick),
      kbbl_conversion_value: Number(kbblConversion),
      price_conversion: Number(priceConversion),
      f_w_months: Number(fwMonths),
      exchange_fees: Number(exchangeFee),
      exchange_clearance_fees: Number(exchangeClearanceFee),
      exchange_fees_blocked: exchangeFeeBlocked,
      exchange_clearance_fees_blocked: exchangeClearanceFeeBlocked,
      screen_fees: screenFee,
      ice_clearer_eu_screen_fees: iceClearEUScreenFee,
      ice_clearer_eu_block_fee: iceClearEUEUBlockFee,
      cash_settle: cashSettle,
      gimfc_code: gmifcCode,
      physical_code: physicalCode,
      logical_code: logicalCode,
      symbol_code: symbolCode,
      platts_code: plattsCode,
      contract1: contract1 || null,
      contract2: contract2 || null,
      major_mini_connection: majorMiniConn || null,
      bal_month_connection: balMonthConn || null,
      unit: unit,
      holiday: holiday,
    };

    await createBroker(counterparty);
    table.setCreatingRow(null);
  };

  //UPDATE action
  const handleeditsave: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    table,
    row,
  }) => {
    // Log the detailed values and table object
    console.log("Saving User - Full Row Original Data:", row.original);
    console.log("Saving User - Edited Values:", values);

    // Merge the edited values with the original row data
    const updatedUser = {
      ...row.original, // Spread the original row data first
      ...values, // Overlay the edited values on top
    };

    console.log("Saving User - Merged User Data:", updatedUser);

    // Validate user data
    const newValidationErrors = validateUser(updatedUser);

    // Check for validation errors
    if (Object.values(newValidationErrors).some((error) => error !== "")) {
      console.log("Validation Errors:", newValidationErrors);
      setValidationErrors(newValidationErrors);
      return;
    }

    // Clear previous validation errors
    setValidationErrors({});

    // Trigger user update mutation
    try {
      await updateUser(updatedUser); // Pass the full, merged user object
      toast.success("Counterparty updated successfully!");
      // Exit editing mode
      table.setEditingRow(null);
    } catch (error) {
      console.error("User Update Error:", error);
      toast.error("Failed to update counterparty. Please try again.");
    }
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<User>) => {
    showDeleteConfirmModal({
      title: "Are you sure you want to delete this Counterparty?",
      content: "Deleting...",
      onOk: () => {
        deleteUser(row.original.id)
          .then(() => {
            toast.success("Contract deleted successfully!");
          })
          .catch((error) => {
            toast.error("Failed to delete user. Please try again.");
          });
      },
    });
  };

  const handleCopyRow = (row: any) => {
    if (!row) return;
    const rowData = row.original; // Get the row data
    let textToCopy = JSON.stringify(rowData, null, 2); // Convert to formatted JSON
     if (navigator?.clipboard?.writeText) {
    navigator.clipboard.writeText(textToCopy).catch((err) => {
      console.error("Clipboard write failed:", err);
    });
  } else {
    const textarea = document.createElement("textarea");
    textarea.value = textToCopy;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }// Copy to clipboard

    let jsonData;

    try {
      jsonData = JSON.parse(textToCopy);
      setBrokerName(jsonData.name);
      window.scrollTo({ top: 0, behavior: "smooth" });
      toast.success("copied and pasted successfully");
      setInputBackgroundColour("#83bf6e26");
      setTimeout(() => {
        setInputBackgroundColour(""); // Then set it again
      }, 2400);
    } catch (error) {
      console.error("Invalid JSON. Pasted as a string:", textToCopy);
      jsonData = { rawText: textToCopy }; // Fallback if not valid JSON
    }
  };

  interface ContextMenuPosition {
    mouseX: number;
    mouseY: number;
  }

  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(
    null
  );

  // Function to handle right-click and open the menu
  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 }
        : null
    );
  };

  // Function to handle menu close
  const handleClose = () => {
    setContextMenu(null);
  };

  // Function to handle Paste action
  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      let jsonData;

      try {
        jsonData = JSON.parse(text);
        setBrokerName(jsonData.name);
        window.scrollTo({ top: 0, behavior: "smooth" });
        toast.success("copied and pasted successfully");
        setInputBackgroundColour("#83bf6e26");
        setTimeout(() => {
          setInputBackgroundColour(""); // Then set it again
        }, 2400);
      } catch (error) {
        console.error("Invalid JSON. Pasted as a string:", text);
        jsonData = { rawText: text }; // Fallback if not valid JSON
      }

      // Here, you can use jsonData further as needed
    } catch (err) {
      console.error("Failed to read clipboard contents:", err);
    }

    handleClose();
  };

  // Function to handle Mark action
  const handleResizing = () => {
    setShowRowResizing(!showRowResizing);
    handleClose();
  };

  const handleExportRows = (rows: MRT_Row<any>[]) => {
    const rowData = rows.map((row) => row.original);
    console.log(rowData);
  };

  const handleDataDownload = async () => {
    try {
      const response = await axiosInstance.get(
        "/paper-app/contracts/csv/download",
        {
          responseType: "blob", // Ensure Axios handles binary data properly
        }
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      // Create a temporary anchor element to trigger the download
      const a = document.createElement("a");
      a.href = url;
      a.download = "persons.csv"; // Set the file name
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Cleanup the URL object
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  const table = useMaterialReactTable({
    columns,

    enableStickyHeader: true,
    enableStickyFooter: true,
    enableClickToCopy: true,
    enableKeyboardShortcuts: true,
    // enableRowNumbers: true,
    enableColumnActions: true,
    enableColumnDragging: true,
    enableGlobalFilter: false,
    enableGrouping: true,
    enableHiding: true,
    enableSorting: true,
    enableColumnPinning: true,
    onPaginationChange: setPagination,
    onColumnFiltersChange: setColumnFilters,
    onColumnVisibilityChange: setColumnVisibility,
    onDensityChange: setDensity,
    onGlobalFilterChange: setGlobalFilter,
    onShowColumnFiltersChange: setShowColumnFilters,
    onShowGlobalFilterChange: setShowGlobalFilter,
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    enableRowSelection: true,
    positionToolbarAlertBanner: "bottom",
    layoutMode: "semantic",
    enableColumnResizing: showRowResizing,
    enableFilterMatchHighlighting: true,
    rowCount: totalCount,
    manualFiltering: true,
    data: data?.results || [],
    enableDensityToggle: false,
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,

    muiTableBodyRowProps: ({ row, table }) => ({
      onKeyDown: (event: React.KeyboardEvent<HTMLTableRowElement>) => {
        if (event.key === "Enter") {
          event.preventDefault();

          const editingRow = table.getState().editingRow;
          if (editingRow) {
            const saveHandler = table.options.onEditingRowSave;
            if (saveHandler) {
              const newedit = {
                ...editingRow.original,
                ...editingRow._valuesCache,
              };
              console.log("Saving:", newedit);

              saveHandler({
                exitEditingMode: () => table.setEditingRow(null),
                row: editingRow,
                table,
                values: newedit,
              });
            }
          }
        }
      },
    }),

    enableColumnOrdering: true, // ✅ Enables column drag-and-drop
    enableRowOrdering: false, // ✅ Enables row drag-and-drop
    getRowId: (row) => row.id,
    enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
    initialState: { showColumnFilters: true }, //show filters by default
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },

    defaultDisplayColumn: {
      enableResizing: true, //turn on some features that are usually off for all display columns
    },
    displayColumnDefOptions: {
      "mrt-row-actions": {
        size: 100, //set custom width
        muiTableHeadCellProps: {
          align: "center", //change head cell props
        },
      },
      "mrt-row-numbers": {
        enableColumnDragging: true,
        enableColumnOrdering: true, //turn on some features that are usually off
        enableResizing: true,
        muiTableHeadCellProps: {
          sx: {
            fontSize: "1.2rem",
          },
        },
      },
      "mrt-row-select": {
        enableColumnActions: true,
        enableHiding: true,
        size: 50,
      },
    },

    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          onClick={() => handleDataDownload()}
          startIcon={<FileDownloadIcon />}
        >
          Export All Data
        </Button>
        {/* <Button
          disabled={table.getPrePaginationRowModel().rows.length === 0}
          //export all rows, including from the next page, (still respects filtering and sorting)

          startIcon={<FileDownloadIcon />}
        >
          Export All Rows
        </Button>
        <Button
          disabled={table.getRowModel().rows.length === 0}
          //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)

          startIcon={<FileDownloadIcon />}
        >
          Export Page Rows
        </Button> */}
        <Button
          disabled={
            !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
          }
          //only export selected rows
          onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
          startIcon={<FileDownloadIcon />}
        >
          Export Selected Rows
        </Button>
        {(table.getIsSomeRowsSelected() || table.getIsAllRowsSelected()) && (
          <Button
            style={{ color: "red" }}
            onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
            startIcon={<DeleteIcon />}
          >
            Delete Selected
          </Button>
        )}
      </Box>
    ),

    // muiTableProps: {
    //   sx: {
    //     border: '1px solid rgba(81, 81, 81, .5)',
    //     caption: {
    //       captionSide: 'top',
    //     },
    //   },
    // },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "italic",
        fontWeight: "normal",
      },
    },

    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,

    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
        color: "error",
        children: "Error loading data",
      }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "400px",
      },
    },

    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleeditsave,

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Copy Row">
          <IconButton onClick={() => handleCopyRow(row)}>
            {" "}
            {/* ✅ Pass row as argument */}
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    state: {
      sorting,
      columnFilters,
      pagination,
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: true,
    },
  });

  const transformedFilters = columnFilters.map((filter) => ({
    ...filter,
    mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
  }));

  useEffect(() => {
    const transformedFilters = columnFilters.map((filter) => ({
      ...filter,
      mode: table.getColumn(filter.id)?.getFilterFn()?.name || "contains",
    }));

    setFilterModes(transformedFilters);
  }, [columnFilters, table]);

  const someEventHandler = (event: any) => {
    console.info("rows :", table.getRowModel().rows); //example - get access to all page rows in the table
    console.info("row model :", table.getSelectedRowModel()); //example - get access to all selected rows in the table
    console.info("row model :", table.getState().sorting); //example - get access to the current sorting state without having to manage it yourself
  };
  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              <Accordion defaultActiveKey="0" className="table-ad__addInputs">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="accordion_button">
                    Add New Counterparty
                  </Accordion.Header>
                  <Accordion.Body>
                    <Form onSubmit={formCreate}>
                      <div className="form_contain">
                        <div
                          className={`flex formWrapper ${inputBackgroundColour !== "" ? "inputboxcustom" : ""
                            }`}
                          style={{ backgroundColor: inputBackgroundColour }}
                        >
                          <Row className="formInpt_row">
                            <Col sm={6} md={3} lg={1}>
                              {inputBackgroundColour && (
                                <div style={{ width: "10%" }}>
                                  <DotLottieReact
                                    src="https://lottie.host/1bd34385-2683-4f42-9359-6f1a346e1a5f/RFVvjz1cPo.lottie"
                                    loop
                                    autoplay
                                  />
                                </div>
                              )}
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="derivative-label">
                                  Derivative
                                </InputLabel>
                                <Select
                                  labelId="derivative-label"
                                  id="derivative-select"
                                  name="derivative"
                                  value={formData.derivative}
                                  onChange={handleChange}
                                  displayEmpty
                                >
                                  <MenuItem value="" disabled>
                                    Select
                                  </MenuItem>
                                  {derivativeOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={2} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="single-diff-label">
                                  Single/Diff
                                </InputLabel>
                                <Select
                                  labelId="single-diff-label"
                                  id="single-diff-select"
                                  value={singleDiff}
                                  onChange={(e: SelectChangeEvent) =>
                                    setSingleDiff(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {singleDiffOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={2} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="major-mini-label">
                                  Major/Mini
                                </InputLabel>
                                <Select
                                  labelId="major-mini-label"
                                  id="major-mini-select"
                                  value={majorMini}
                                  onChange={(e: SelectChangeEvent) =>
                                    setMajorMini(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {majorMiniOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={2} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="full-bal-month-label">
                                  Full/Bal Month
                                </InputLabel>
                                <Select
                                  labelId="full-bal-month-label"
                                  id="full-bal-month-select"
                                  value={fullBalMonth}
                                  onChange={(e: SelectChangeEvent) =>
                                    setFullBalMonth(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {fullBalMonthOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={4} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Contract Name"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={contractName}
                                onChange={(e) =>
                                  setContractName(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="contract1-label">
                                  Contract 1
                                </InputLabel>
                                <Select
                                  labelId="contract1-label"
                                  id="contract1-select"
                                  value={contract1}
                                  onChange={(e: SelectChangeEvent) =>
                                    setContract1(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {contract1Options.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="contract2-label">
                                  Contract 2
                                </InputLabel>
                                <Select
                                  labelId="contract2-label"
                                  id="contract2-select"
                                  value={contract2}
                                  onChange={(e: SelectChangeEvent) =>
                                    setContract2(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {contract2Options.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="major-mini-conn-label">
                                  Major Mini Connection
                                </InputLabel>
                                <Select
                                  labelId="major-mini-conn-label"
                                  id="major-mini-conn-select"
                                  value={majorMiniConn}
                                  onChange={(e: SelectChangeEvent) =>
                                    setMajorMiniConn(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {majorMiniConnOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="bal-month-conn-label">
                                  Bal Month Connection
                                </InputLabel>
                                <Select
                                  labelId="bal-month-conn-label"
                                  id="bal-month-conn-select"
                                  value={balMonthConn}
                                  onChange={(e: SelectChangeEvent) =>
                                    setBalMonthConn(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {balMonthConnOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="unit-label">Unit</InputLabel>
                                <Select
                                  labelId="unit-label"
                                  id="unit-select"
                                  value={unit}
                                  onChange={(e: SelectChangeEvent) =>
                                    setUnit(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {unitOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Tick"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={tick}
                                onChange={(e) => setTick(e.target.value)}
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <FormControl sx={{ m: 1, minWidth: 120 }}>
                                <InputLabel id="holiday-label">
                                  Holiday
                                </InputLabel>
                                <Select
                                  labelId="holiday-label"
                                  id="holiday-select"
                                  value={holiday}
                                  onChange={(e: SelectChangeEvent) =>
                                    setHoliday(e.target.value)
                                  }
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {holidayOptions.map((option) => (
                                    <MenuItem
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="kbbl Conversion value"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={kbblConversion}
                                onChange={(e) =>
                                  setKbblConversion(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Price Conversion Value"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={priceConversion}
                                onChange={(e) =>
                                  setPriceConversion(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="F.W Months"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={fwMonths}
                                onChange={(e) => setFwMonths(e.target.value)}
                              />
                            </Col>

                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Exchange Fee"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={exchangeFee}
                                onChange={(e) => setExchangeFee(e.target.value)}
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Exchange Clearance Fee"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={exchangeClearanceFee}
                                onChange={(e) =>
                                  setExchangeClearanceFee(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Exchange Fees (Blocked)"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={exchangeFeeBlocked}
                                onChange={(e) =>
                                  setExchangeFeeBlocked(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Exchange Clearance Fee (Blocked)"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={exchangeClearanceFeeBlocked}
                                onChange={(e) =>
                                  setExchangeClearanceFeeBlocked(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Screen Fee"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={screenFee}
                                onChange={(e) => setScreenFee(e.target.value)}
                                disabled={formData.derivative === "future"}
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="ICE Clear EU Screen Fee"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={iceClearEUScreenFee}
                                onChange={(e) =>
                                  setIceClearEUScreenFee(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="ICE Clear EU EU Block Fee"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={iceClearEUEUBlockFee}
                                onChange={(e) =>
                                  setIceClearEUEUBlockFee(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={2}>
                              <TextField
                                id="outlined-basic"
                                label="Cash Settle"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={cashSettle}
                                onChange={(e) => setCashSettle(e.target.value)}
                              />
                            </Col>

                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="GMIFC Code"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={gmifcCode}
                                onChange={(e) => setGmifcCode(e.target.value)}
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Physical Code"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={physicalCode}
                                onChange={(e) =>
                                  setPhysicalCode(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Logical Code"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={logicalCode}
                                onChange={(e) => setLogicalCode(e.target.value)}
                              />
                            </Col>
                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Symbol Code"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={symbolCode}
                                onChange={(e) => setSymbolCode(e.target.value)}
                              />
                            </Col>

                            <Col sm={6} md={3} lg={1}>
                              <TextField
                                id="outlined-basic"
                                label="Platts Code"
                                className="border-1 w-100"
                                variant="outlined"
                                size="small"
                                value={plattsCode}
                                onChange={(e) => setPlattsCode(e.target.value)}
                              />
                            </Col>

                            <Col sm={6} md={3} lg={1}>
                              <div className="add_btn align-items-end d-flex h-100 justify-content-start">
                                <Button
                                  variant="contained"
                                  className="add_button"
                                  type="submit"
                                >
                                  Add
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </Form>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div
                className="table-ad__wrapper"
                onContextMenu={handleContextMenu}
              >
                <StyledTableFirstSecond>
                  <MaterialReactTable table={table} />
                </StyledTableFirstSecond>

                {/* Context Menu */}
                <Menu
                  open={contextMenu !== null}
                  onClose={handleClose}
                  anchorReference="anchorPosition"
                  anchorPosition={
                    contextMenu !== null
                      ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                      : undefined
                  }
                >
                  {/* <MenuItem onClick={handlePaste}>Paste</MenuItem> */}
                  <MenuItem onClick={handleResizing}>
                    {showRowResizing ? "Disable Resizing" : "enable Resizing"}
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

//CREATE hook (post new user to api)
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        ["users"],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//READ hook (get users from api)
function useGetData(
  filterModes: { mode: string; id: string; value: unknown }[],
  pagination: { pageIndex: number; pageSize: number },
  setTotalCount: any,
  sorting: any
) {
  return useQuery<{ results: User[]; totalCount: number }>({
    // ✅ Correct return type
    queryKey: ["users", filterModes, pagination, sorting], // Ensure proper re-fetching
    queryFn: async () => {
      let url = `${backendbaseUrl}/paper-app/contracts/?page=${pagination.pageIndex + 1
        }&page_size=${pagination.pageSize}`;

      if (filterModes.length > 0) {
        console.log("filterModes---,", filterModes);
        const queryParams = filterModes
          .map((e) => `fieldName__d39d26f3-8442-44d0-8a7f-66cfcbb2c781__${e.id}=${String(e.value)}__d39d26f3-8442-44d0-8a7f-66cfcbb2c781__${e.mode}`)
          .join("&");

        url += `&${queryParams}`;
      }
      console.log("sortparams:", sorting);
      if (sorting.length > 0) {
        const sortParams = `sortField_${sorting[0].id}=${sorting[0].desc}_sorting`;
        url += `&${sortParams}`;

        console.log("yesss");
      } else {
        console.log("sortParams");
      }

      const response = await axiosInstance.get(url);
      console.log("response", response.data);
      setTotalCount(response.data.count);
      return {
        results: response.data.results as User[],
        totalCount: response.data.count as number,
      };
    },
    refetchOnWindowFocus: false,
  });
}

function useUpdateUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (user: User) => {
      // Comprehensive logging
      console.group("🔄 User Update Mutation");
      console.log("Input User Object:", user);

      // Validate basic requirements
      if (!user || !user.id) {
        console.error("❌ Invalid user object:", user);
        throw new Error("User object is invalid or missing ID");
      }

      // Prepare payload - now using the full user object
      const payload = user;

      console.log("📦 Prepared Payload:", payload);

      try {
        // Fixed API endpoint to use counterparty-companies instead of brokers
        const { data } = await axiosInstance.put(
          `${backendbaseUrl}/paper-app/contracts/${payload.id}/`,
          user
        );
        console.log("✅ API Response:", data);
        console.groupEnd();
        return data;
      } catch (error) {
        console.error("❌ API Request Failed:", error);
        console.groupEnd();
        throw error;
      }
    },

    // Rest of the mutation remains the same
    onMutate: async (newUserInfo: User) => {
      console.log("🔮 Optimistic Update - New User Info:", newUserInfo);

      // Cancel ongoing queries
      await queryClient.cancelQueries({ queryKey: ["users"] });

      // Snapshot previous data
      const previousUsers = queryClient.getQueryData(["users"]);

      // Optimistically update cache
      queryClient.setQueryData(["users"], (oldData: any) => {
        if (Array.isArray(oldData?.results)) {
          return {
            ...oldData,
            results: oldData.results.map((prevUser: User) =>
              prevUser.id === newUserInfo.id ? newUserInfo : prevUser
            ),
          };
        }
        return oldData;
      });

      return { previousUsers };
    },

    onError: (err, newUser, context) => {
      console.error("❌ Update Failed:", err);

      // Rollback optimistic update
      queryClient.setQueryData(["users"], context?.previousUsers);
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      //send api update request here
      // await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      try {
        await axiosInstance.delete(
          `${backendbaseUrl}/paper-app/contracts/${userId}/`
        );
        console.log("userId", userId);
      } catch (error) {
        console.error("Error deleting user:", error);
        throw error;
      }

      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: async (userId: string) => {
      await queryClient.cancelQueries({ queryKey: ["users"] });

      const previousUsers = queryClient.getQueryData(["users"]);

      queryClient.setQueryData(["users"], (prevUsers: any) =>
        prevUsers?.filter((user: User) => user.id !== userId)
      );

      return { previousUsers };
    },
    onError: (err, userId, context) => {
      console.error("❌ Delete Failed:", err);
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: ["users"] }), //refetch users after mutation, disabled for demo
  });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

function validateUser(user: User) {
  return {
    // brokerName: !validateRequired(user.name)
    //   ? "First Name is Required"
    //   : "",
    // name: !validateRequired(user.name) ? "Last Name is Required" : "",
    // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
  };
}
